<template>
  <!-- 210304 | id 추가 -->
  <section
    id="recruit"
    class="recruit"
  >
    <ul class="recruit__inner">
      <li class="recruit__left">
        <div class="recruit__txtBox">
          <h2 class="title">
            UILab에서는 항상, <br>함께 할 인재를 기 다리고 있습니다
          </h2>
          <p class="description description--recruit">
            프론트엔드 엔지니어로 거듭나고 싶은 웹퍼블리셔, 백엔드 개발자, 관련 전공자를 모십니다. UI Lab은 함께 배우며 고민하고 성장합니다.
          </p>
          <ul class="recruit__buttons">
            <li class="recruit__buttonitem">
              <button 
                type="button" 
                class="button button--primary button--large"
                @click="requestRecruit"
              >
                문의하기
              </button>
            </li>
            <li class="recruit__buttonitem">
              <button 
                type="button" 
                class="button button--large"
                @click="requestRecruit"
              >
                입사 지원하기
              </button>
            </li>
          </ul>
          <span class="guidetext">* 입사 지원시 자기소개서를 포함한 이력서와 프로젝트 경험, 포트폴리오를 보내주세요 </span>  
        </div>          
      </li>
      <li class="recruit__right">
        <div class="recruit__imgBox">
          <img
            class="person__arm"
            src="@/assets/images/img-person_arm.png"
          >
          <img
            class="person__jump"
            src="@/assets/images/img-person_jump.png"
          >
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
	name: 'Recruitment',
  methods: {
    requestRecruit() {
      window.location = 'mailto:hello@ui-lab.co.kr'
    }
  }
}
</script>

<style lang="scss" scoped>
.recruit{
  $self:&;
  width:100%;
  background-color: #f0f0f3;
  height:634px;
  padding: 160px 0;
  &:after{
    clear:both;
    display:block;
    content:'';
  }
  &__inner{
    width:1000px;
    margin:0 auto;
  }
  &__left{
    width:45%;
    float:left;
  }
  &__right{
    width:45%;
    float: left;
  }
  &__txtBox{
    padding-top:19px;
  }
  &__imgBox{
    padding-left:149px;
    width:483px;
    height:314px;
    background:url('~@/assets/images/img-person.png') no-repeat right bottom;
    position: relative;
    img {
      position: absolute;
    }
    .person__arm {
      top:71px;
      left:221px;
      animation: flicker 5s ease alternate infinite;
    }
    .person__jump {
      top:65px;
      left:300px;
      animation: flicker2 4s ease alternate infinite;
    }
  }
  &__buttons{    
    margin-bottom:18px;
    &:after{
      clear:both;
      display:block;
      content:'';
    }
  }
  &__buttonitem{
    width: 162px;
    height: 50px;
    float:left;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
@keyframes flicker {
  0% {
    transform: rotate(-8deg)
  } 50% {
    transform: rotate(7deg);
  } 100% {
    transform: rotate(-8deg);
  }
}
@keyframes flicker2 {
  0% {
    transform: translateY(0)
  } 4% {
    transform: translateY(-10px)
  } 7% {
    transform: translateY(0)
  } 92% {
    transform: translateY(0)
  } 95% {
    transform: translateY(-10px)
  } 100% {
    transform: translateY(0)
  }
}
</style>